var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 156,
    viewBox: "0 0 150 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6385 19.7824C60.5536 0.865164 84.728 -5.61637 103.634 5.30552L105.982 6.66199C123.59 16.8347 129.624 39.365 119.457 56.9847C118.473 58.6895 116.295 59.2736 114.591 58.2893C112.887 57.305 112.304 55.1251 113.287 53.4203C121.486 39.2102 116.621 21.0399 102.419 12.8357L100.071 11.4792C84.5734 2.52587 64.7561 7.83917 55.8083 23.3468L31.3242 65.781C31.3979 65.8171 31.4708 65.8559 31.5429 65.8976L62.378 83.7113C64.0818 84.6955 64.6655 86.8755 63.6819 88.5803C62.6982 90.2851 60.5196 90.8692 58.8158 89.885L27.9808 72.0713C27.9087 72.0296 27.8385 71.9858 27.7705 71.94L11.4593 100.209C2.51536 115.71 7.86629 135.572 23.3709 144.529C38.819 153.454 58.6122 148.179 67.5235 132.735C68.5071 131.03 70.6857 130.446 72.3895 131.43C74.0932 132.414 74.677 134.594 73.6933 136.299C62.8071 155.166 38.6511 161.588 19.8088 150.703C0.909847 139.785 -5.62945 115.569 5.28948 96.6449L49.6385 19.7824Z",
    fill: "#0446B8",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.065 83.4688L123.874 109.527C122.551 113.279 119.658 116.266 115.953 117.708L88.3469 128.45L97.678 101.47C99.0348 97.5467 102.102 94.4545 106.012 93.0672L133.065 83.4688ZM109.207 99.4973L117.198 107.036L121.38 95.1783L109.207 99.4973ZM111.75 111.694L104.158 104.532L100.115 116.222L111.75 111.694Z",
    fill: "#0446B8",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150 105.83C150 127.533 132.417 145.127 110.727 145.127C89.0373 145.127 71.4543 127.533 71.4543 105.83C71.4543 84.1267 89.0373 66.5328 110.727 66.5328C132.417 66.5328 150 84.1267 150 105.83ZM142.876 105.83C142.876 123.596 128.482 137.999 110.727 137.999C92.972 137.999 78.5786 123.596 78.5786 105.83C78.5786 88.0638 92.972 73.6615 110.727 73.6615C128.482 73.6615 142.876 88.0638 142.876 105.83Z",
    fill: "#0446B8",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/Medication.d97ccb5b7b6c1edf6357eed5caa0c2c0.svg";
export { ForwardRef as ReactComponent };